import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { ActionSelect } from '../../Action'
import { QA_NAME_CHATROOM_MESSAGE_ACTIONS } from '../Chatroom.constants'
import { useChatroomMessageActions } from '../ChatroomMessage'

import { getChatroomMessageActionsItems } from './ChatroomMessageActions.utils'

function ChatroomMessageActions({
  message,
  outboundUuid,
  onEditMessage,
  onRefetchVisibleMessages,
  onUpdateMessage,
}) {
  const { t } = useTranslation()

  const {
    handleClickAttachRequest,
    handleClickCreateRequest,
    handleClickDelete,
    handleClickEdit,
    modal,
  } = useChatroomMessageActions({
    message,
    outboundUuid,
    onEditMessage,
    onRefetchVisibleMessages,
    onUpdateMessage,
  })

  const actions = getChatroomMessageActionsItems({
    message,
    t,
    onClickAttachRequest: handleClickAttachRequest,
    onClickCreateRequest: handleClickCreateRequest,
    onClickDelete: handleClickDelete,
    onClickEdit: handleClickEdit,
  })

  function handleClickAction({ value }) {
    actions.find(action => action.value === value)?.onClick?.()
  }

  return actions.length === 0 ? null : (
    <>
      <ActionSelect
        actions={actions}
        controlProps={{
          buttonProps: { qaName: QA_NAME_CHATROOM_MESSAGE_ACTIONS },
        }}
        dropdownFloatingConfig={{
          placement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
        }}
        onClickAction={handleClickAction}
      />
      {modal}
    </>
  )
}

export default ChatroomMessageActions
